import { render, staticRenderFns } from "./sso-wsfed.vue?vue&type=template&id=3a99559a&scoped=true&"
import script from "./sso-wsfed.ts?vue&type=script&lang=ts&"
export * from "./sso-wsfed.ts?vue&type=script&lang=ts&"
import style0 from "./sso-wsfed.scss?vue&type=style&index=0&id=3a99559a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99559a",
  null
  
)

export default component.exports